// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"25cff175","902":"0cddc273"}[chunkId] + ".chunk.js";
};